module.exports = __webpack_public_path__ + "img/contrast_circle_symbol.ff3ad8cd.svg";